module.exports = __webpack_public_path__ + "img/avatar-generic.e0594b7c.svg";